"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaResultRegisterContainer = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _KansaRegisterEntry = _interopRequireDefault(require("./KansaRegisterEntry"));
var _KansaRegisterResult = _interopRequireDefault(require("./KansaRegisterResult"));
var _kansaResultRegisterActions = require("./kansaResultRegisterActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査結果登録機能コンテナ
 * @prop {object} [loginUserInfo] - 登録対象者情報
 * @prop {string} dispContent - 画面表示情報
 * @prop {object} btnProps - 戻るボタンの情報
 * @prop {string} btnProps.label - 戻るボタンのラベル
 * @prop {func} btnProps.onClick - 戻るボタン押下時の動作
 * @prop {bool} [upd] - 更新フラグ
 * シグネチャ（search : boolean）=> {}
 */
class KansaResultRegisterContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    const {
      kansaInfo,
      loginUserInfo,
      setUserInfo,
      setKansaInfo
    } = props;
    setUserInfo(loginUserInfo);
    setKansaInfo(kansaInfo);
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      dispContent,
      btnProps,
      upd
    } = this.props;
    if (dispContent === _kansaResultRegisterActions.CONTENTS_REG.ENTER) {
      return /*#__PURE__*/_react.default.createElement(_KansaRegisterEntry.default, {
        returnBtn: className => /*#__PURE__*/_react.default.createElement(_CButton.default, {
          negative: true,
          autoWidth: true,
          className: className,
          onClick: btnProps.onClick(false)
        }, btnProps.label),
        upd: upd
      });
    } else if (dispContent === _kansaResultRegisterActions.CONTENTS_REG.RESULT) {
      return /*#__PURE__*/_react.default.createElement(_KansaRegisterResult.default, {
        returnBtn: className => /*#__PURE__*/_react.default.createElement(_CButton.default, {
          negative: true,
          autoWidth: true,
          className: className,
          onClick: btnProps.onClick(true)
        }, btnProps.label)
      });
    }
  }
}
exports.KansaResultRegisterContainer = KansaResultRegisterContainer;
KansaResultRegisterContainer.propTypes = {
  userInfo: _propTypes.default.shape({
    kaishaCd: _propTypes.default.string,
    shainId: _propTypes.default.string,
    shainNm: _propTypes.default.string,
    kaishaNm: _propTypes.default.string,
    soshikiNm: _propTypes.default.string
  }),
  dispContent: _propTypes.default.string,
  btnProps: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  }).isRequired,
  upd: _propTypes.default.bool
};
const mapStateToProps = state => {
  return {
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    dispContent: state.kansaResultRegister.dispContent,
    entries: state.kansaResult.entries
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntry: key => value => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_ENTRY](key, value));
    },
    setEntries: entries => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_ENTRIES](entries)),
    setUserInfo: userInfo => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_USER_INFO](userInfo)),
    setKansaInfo: kansaInfo => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_KANSA_INFO](kansaInfo)),
    setReturnBtn: btn => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.SET_RETURN_BTN](btn)),
    clear: () => dispatch(_kansaResultRegisterActions.kansaResultRegisterActions[_kansaResultRegisterActions.TYPES_REG.CLEAR]()),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  };
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CallAPI.withCallAPI)(KansaResultRegisterContainer)));